// ==============================================================================
// VERSION INFORMATION
// ==============================================================================
// __version__ = "1.2.0"
//
// Changelog:
//
// Version 1.2.0:
// - [Changed] Replaced the "Made by" branding with a formal copyright notice
//   for legal clarity and professionalism.
// - [Removed] Removed the ClarityLB LLC logo import as it is no longer used.
//
// Version 1.1.1:
// - [Changed] Increased the size of the ClarityLB logo and applied the app's
//   primary theme color for better visibility and branding consistency.
//
// Version 1.1.0:
// - [Added] A footer section to display "Made by ClarityLB LLC" with the
//   company logo, providing branding on all authentication-related pages.
//
// ==============================================================================
// src/layouts/AuthLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { APP_NAME } from '../config';
import logoSrc from '../assets/icons/Logo512.png';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral-light flex flex-col justify-center items-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
        <div className="flex flex-col items-center">
          <img
            className="h-24 w-24 mb-4"
            src={logoSrc} 
            alt="LifeLine App Logo"
          />
          <h2 className="text-3xl font-extrabold text-primary">
            {APP_NAME}
          </h2>
        </div>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-xl rounded-lg sm:px-10">
          <Outlet />
        </div>
      </div>
      <div className="mt-8 text-center">
        <p className="text-sm text-neutral-dark">
          © 2025 ClarityLB LLC. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;